import { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { FiArrowRight, FiMoon, FiSun } from 'react-icons/fi'
import { ThemeContext } from '../../theme/ThemeContext'
import logo from '../../Assets/logo.svg'
import { LanguageSelectorButtons } from '../../Components/LanguageSelector'
import { Page, Header, Brand, Nav, AccessButton, Hero, Intro, Title, Description, Actions, TextLink, HeroArtwork, Modules, SectionHeading, FeatureGrid, Feature, FeatureImage, FeatureCopy, SupportingModules, AccessSection, AccessDetails, Footer, ThemeButton } from './Landing.styles'
const team = '/landing/team.webp'
const teamSmall = '/landing/team-small.webp'
const warehouse = '/landing/warehouse.webp'
const warehouseSmall = '/landing/warehouse-small.webp'
const documents = '/landing/documents.webp'
const documentsSmall = '/landing/documents-small.webp'

export class Landing extends Component {
  static contextType = ThemeContext

  componentDidMount () {
    if (this.context?.isDark) this.context.setTheme('light')
  }

  handleGoToLogin = () => this.props.navigate('/login')

  toggleAppearance = () => this.context?.toggleTheme?.()

  render () {
    const { t } = this.props
    const isDark = this.context?.isDark || false
    return (
      <Page>
        <Header>
          <Brand href='/' aria-label='EMS'><img src={logo} alt='' width='30' height='30' /><span>EMS</span></Brand>
          <Nav aria-label={t('nav.label')}>
            <TextLink href='#modules'>{t('nav.features')}</TextLink>
            <TextLink href='#access'>{t('nav.access')}</TextLink>
          </Nav>
          <div className='language'><LanguageSelectorButtons /></div>
          <ThemeButton onClick={this.toggleAppearance} aria-label={t('theme.toggle')} title={t('theme.toggle')}>{isDark ? <FiSun /> : <FiMoon />}</ThemeButton>
          <AccessButton onClick={this.handleGoToLogin}>{t('nav.login')} <FiArrowRight aria-hidden='true' /></AccessButton>
        </Header>

        <main>
          <Hero>
            <Intro>
              <Title>{t('hero.title')} <span>{t('hero.titleAccent')}</span></Title>
              <Description>{t('hero.description')}</Description>
              <Actions>
                <AccessButton onClick={this.handleGoToLogin}>{t('nav.login')} <FiArrowRight aria-hidden='true' /></AccessButton>
                <TextLink href='#modules'>{t('hero.explore')} <FiArrowRight aria-hidden='true' /></TextLink>
              </Actions>
            </Intro>
            <HeroArtwork><img src={team} srcSet={`${teamSmall} 640w, ${team} 1200w`} sizes='(max-width: 767px) calc(100vw - 40px), 52vw' width='1200' height='800' fetchpriority='high' alt={t('images.team')} /></HeroArtwork>
          </Hero>

          <Modules id='modules'>
            <SectionHeading><h2>{t('features.title')}</h2><p>{t('features.description')}</p></SectionHeading>
            <FeatureGrid>
              <Feature $kind='warehouse'>
                <FeatureImage><img src={warehouse} srcSet={`${warehouseSmall} 480w, ${warehouse} 900w`} sizes='(max-width: 767px) calc(100vw - 72px), 46vw' width='900' height='600' loading='lazy' decoding='async' alt={t('images.warehouse')} /></FeatureImage>
                <FeatureCopy><h3>{t('features.inventory.title')}</h3><p>{t('features.inventory.desc')}</p></FeatureCopy>
              </Feature>
              <Feature $kind='documents'>
                <FeatureCopy><h3>{t('features.invoicing.title')}</h3><p>{t('features.invoicing.desc')}</p></FeatureCopy>
                <FeatureImage><img src={documents} srcSet={`${documentsSmall} 480w, ${documents} 900w`} sizes='(max-width: 767px) calc(100vw - 72px), 38vw' width='900' height='600' loading='lazy' decoding='async' alt={t('images.documents')} /></FeatureImage>
              </Feature>
            </FeatureGrid>
            <SupportingModules>
              <article><h3>{t('features.crm.title')}</h3><p>{t('features.crm.desc')}</p></article>
              <article><h3>{t('features.analytics.title')}</h3><p>{t('features.analytics.desc')}</p></article>
            </SupportingModules>
          </Modules>

          <AccessSection id='access'>
            <div><h2>{t('access.title')}</h2><p>{t('access.description')}</p><AccessButton onClick={this.handleGoToLogin}>{t('nav.login')} <FiArrowRight aria-hidden='true' /></AccessButton></div>
            <AccessDetails>
              <details open><summary>{t('access.accountTitle')}</summary><p>{t('access.accountText')}</p></details>
              <details><summary>{t('access.signInTitle')}</summary><p>{t('access.signInText')}</p></details>
              <details><summary>{t('access.companyTitle')}</summary><p>{t('access.companyText')}</p></details>
            </AccessDetails>
          </AccessSection>
        </main>

        <Footer><Brand href='/' aria-label='EMS'><img src={logo} alt='' width='30' height='30' /><span>EMS</span></Brand><span>© {new Date().getFullYear()} Enterprise Management System</span><TextLink href='#access'>{t('footer.support')}</TextLink></Footer>
      </Page>
    )
  }
}

export default withTranslation('landing')(Landing)
